import { render } from "./KritikSaran.vue?vue&type=template&id=077c7358"
import script from "./KritikSaran.vue?vue&type=script&lang=js"
export * from "./KritikSaran.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__